import React from 'react'

export default function Footer () {
  return (
    <footer className="footer">
      <h3 className="footer__title">Developed by Anvar</h3>
    </footer>
  )
}
